import Wallet from 'ethereumjs-wallet'

const getUtc = async (content, passphrase) => {
  return new Promise((resolve, reject) => {
    try {
      const myWallet = Wallet.fromV3(content, passphrase, true)

      const credentials = {
        PrivateKey: myWallet.getPrivateKey().toString('hex'),
        Address: myWallet.getAddress().toString('hex')
      }

      resolve(credentials)
    } catch (error) {
      reject(error)
    }
  })
}

export { getUtc }
